module.exports = __webpack_public_path__ + "img/旋转地球.e3201e5d.gif";